import { wrapSyncFunc } from '../../util';
export var digits = wrapSyncFunc(function (rule, value) {
  if (typeof value === 'number') {
    return Math.floor(value) === value && Number.isFinite(value);
  }

  if (typeof value !== 'string' || value === '') {
    return;
  }

  return /^\d+$/.test(value);
});